var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLootbox = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 34,
    viewBox: "0 0 32 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.3338 7.37776L18.8632 2.5697C17.0959 1.56658 14.9041 1.56658 13.1368 2.5697L4.66624 7.37776C2.94141 8.35681 1.88235 10.1436 1.88235 12.0746L1.88235 21.9274C1.88235 23.8584 2.94141 25.6451 4.66624 26.6242L13.1368 31.4323C14.9041 32.4354 17.0959 32.4354 18.8632 31.4323L27.3338 26.6242C29.0586 25.6451 30.1176 23.8584 30.1176 21.9274L30.1176 12.0746C30.1176 10.1436 29.0586 8.35681 27.3338 7.37776ZM19.8176 1.0041C17.4612 -0.333397 14.5388 -0.333396 12.1824 1.0041L3.71185 5.81216C1.41207 7.11756 0 9.49992 0 12.0746L0 21.9274C0 24.502 1.41208 26.8844 3.71185 28.1898L12.1824 32.9979C14.5388 34.3353 17.4612 34.3353 19.8176 32.9979L28.2881 28.1898C30.5879 26.8844 32 24.502 32 21.9274L32 12.0746C32 9.49992 30.5879 7.11756 28.2881 5.81216L19.8176 1.0041Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 10.4555L23.7143 9.00098H8.28571L7 10.4555V15.3646L8.16839 17.001L7 18.6373V23.5464L8.28571 25.001H23.7143L25 23.5464V18.6373L23.8316 17.001L25 15.3646V10.4555ZM8.28571 11.0578L8.81808 10.4555H23.1815L23.7139 11.0578V14.8505L22.6978 16.2737H19.3746L18.0889 14.0919H13.9103L12.6246 16.2737H9.30183L8.28571 14.8505V11.0578ZM18.2584 17.001L17.4014 18.4555H14.599L13.742 17.001L14.599 15.5464H17.4014L18.2584 17.001ZM8.81808 23.5464L8.28571 22.9442V19.1514L9.30183 17.7282H10.375V23.5464H8.81808ZM11.6603 23.5464V17.7282H12.6246L13.9103 19.9101H18.0889L19.3746 17.7282H20.3389V23.5464H11.6603ZM23.7139 22.9442L23.1815 23.5464H21.6246V17.7282H22.6978L23.7139 19.1514V22.9442Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLootbox);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lootbox.efd9f78e5569305b7e28479b0090ca01.svg";